import { render, staticRenderFns } from "./DictCivilPositionIncRateListPage.vue?vue&type=template&id=224447c8&"
import script from "./DictCivilPositionIncRateListPage.vue?vue&type=script&lang=ts&"
export * from "./DictCivilPositionIncRateListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports